import React from 'react'

import AddContactRequest from './items/add_contact_request'
import { CallContainer } from './items/call/call_container'
import Chat from './items/chat'
import { Meeting } from './items/meeting'
import Note from './items/note'
import Status from './items/status'
import { TaskTimeline } from './items/task_timeline'

export type TimelineComponent = {
  timeline?: any
  groupTogether?: boolean
}

export const TimelineComponent = ({
  timeline,
  groupTogether,
}: TimelineComponent) => {
  const props: any = { timeline }
  switch (timeline.tl_type) {
    case 'AddContactRequest':
      return <AddContactRequest {...props} />
    case 'Call':
      return <CallContainer {...props} />
    case 'Chat':
      return (
        <Chat
          {...props}
          showReply
          avatarType={groupTogether ? 'spacer' : 'popup'}
          withTimelineInfo={!groupTogether}
        />
      )
    case 'Note':
      return <Note {...props} />
    case 'Status':
      return <Status {...props} />
    case 'Meeting':
      return <Meeting {...props} />
    case 'Task':
      return (
        <TaskTimeline
          {...props}
          avatarType={groupTogether ? 'spacer' : 'popup'}
          withTimelineInfo={!groupTogether}
        />
      )
    default:
      return null
  }
}
